export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Valoraciones de huéspedes",
    subtitle: "Pide una reseña por WhatsApp el día del check-out. Configura el enlace donde quieres que dejen su opinión.",
    bulkNotice: "Este cambio se aplicará a los {count} alojamientos vinculados a este anuncio.",
    enableTitle: "Habilitar Valoraciones de huéspedes",
    enableSub: "Se envía automáticamente un mensaje por WhatsApp el día del check-out solicitando una reseña.",
    modeSingleTitle: "Un único link",
    modeSingleSub: "El mismo para todas las reservas",
    modePerOtaTitle: "Un link por OTA",
    modePerOtaSub: "Según el canal de la reserva",
    linkLabel: "Enlace de reseñas",
    singleUrlPlaceholder: "https://g.page/r/… o el enlace del sitio de reseñas",
    otaNamePlaceholder: "Nombre del sitio",
    otaUrlPlaceholder: "https://… enlace de reseñas",
    removeTitle: "Quitar",
    addOta: "Añadir otro sitio",
    saving: "Guardando…",
    saveConfig: "Guardar configuración",
    note: "Los huéspedes recibirán el enlace correspondiente según cómo reservaron.",
    toastLoadError: "Error al cargar los datos del anuncio.",
    urlErrorProtocol: "La URL debe comenzar con http:// o https://",
    urlErrorInvalid: "Ingresa una URL válida (ej: https://g.page/...)",
    toastStateUpdated: "Estado actualizado correctamente",
    toastStateError: "Ocurrió un error al actualizar el estado",
    toastUrlRequired: "Ingresa una URL antes de guardar",
    toastSaved: "Configuración guardada correctamente",
    toastSaveError: "Ocurrió un error al guardar",
  },

  // AccessSummary.vue
  access: {
    tag: "Cerraduras y acceso",
    dynamicTitle: "Cerradura inteligente conectada",
    dynamicDetail: "Cada reserva genera una clave nueva automáticamente y se envía al huésped.",
    chipCheckin: "Se envía al completar el check-in",
    chipTime: "Se envía a las {time} el día de llegada",
    chipManual: "La envías tú manualmente",
    staticTitle: "Cerradura con código fijo",
    staticDetail: "El huésped recibe la clave del cajetín o cerradura para entrar.",
    noneTitle: "Entrego las llaves en mano",
    noneDetail: "Coordinas la entrega de la llave con el huésped a su llegada.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Actualizar precio",
    saving: "Guardando…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Vincula cada unidad de este anuncio con su establecimiento de Mossos (cada unidad puede tener su propio Id. policial). Los check-in se enviarán automáticamente al establecimiento correcto según la unidad de la reserva.",
    wholeListing: "Todo el anuncio",
    wholeListingDefault: "Todo el anuncio (por defecto)",
    unitNumber: "Unidad #{id}",
    badgeSendError: "Error de envío",
    badgeConnected: "Conectado",
    badgeNoCredentials: "Sin credenciales",
    emptyList: "Aún no hay conexiones. Añade una por cada unidad del anuncio.",
    addConnection: "Agregar conexión",
    editConnection: "Editar conexión",
    newConnection: "Nueva conexión",
    unit: "Unidad",
    unitPlaceholder: "Elige la unidad",
    unitHint: "A qué unidad del anuncio pertenece este establecimiento.",
    step1Title: "Acceso a la web de Mossos",
    usuariLabel: "Usuari (web de Mossos)",
    savedHint: "guardado",
    usuariPlaceholderKeep: "Dejar en blanco para no cambiar",
    usuariPlaceholderNew: "Usuario de acceso a la web",
    passLabel: "Paraula de pas",
    passBlankHint: "en blanco para no cambiar",
    passPlaceholder: "Contraseña de la web de Mossos",
    validateHint: "Valida para traer los establecimientos de tu cuenta.",
    searching: "Buscando…",
    validateSearch: "Validar y buscar establecimientos",
    step2Title: "Establecimiento de esta unidad",
    establishmentPlaceholder: "Selecciona el establecimiento",
    revalidateHint: "Valida de nuevo para cambiarlo.",
    validateAbove: "Valida arriba para elegir el establecimiento de esta unidad.",
    checkinTime: "Hora de facturación (entrada)",
    checkoutTime: "Hora de salida",
    cancel: "Cancelar",
    savingBtn: "Guardando...",
    updateConnection: "Actualizar conexión",
    saveConnection: "Guardar conexión",
    warnCredentials: "Introduce el usuari y la paraula de pas de la web de Mossos.",
    foundEstablishments: "Se encontraron {count} establecimiento(s). Elige el de esta unidad.",
    noEstablishments: "No se encontraron establecimientos en esta cuenta.",
    connectError: "No se pudo conectar con Mossos. Revisa usuari y contraseña.",
    validateFirst: "Valida y elige el establecimiento de esta conexión.",
    savedOk: "Conexión Mossos guardada.",
    saveError: "No se pudo guardar la conexión.",
    saveErrorGeneric: "Error guardando la conexión Mossos.",
    confirmDelete: `¿Eliminar la conexión de "{unit}" ({id})?`,
    deletedOk: "Conexión eliminada.",
    deleteError: "No se pudo eliminar la conexión.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Cada unidad comunica sus viajeros con una cuenta de SES Hospedajes. Puedes usar una sola para todo el anuncio o poner una distinta a algunas unidades, por ejemplo si cada apartamento tiene su propio código de establecimiento.",
    defaultName: "Establecimiento {code}",
    badgeConnected: "Conectada",
    badgeError: "Error de validación",
    badgePending: "Sin validar",
    user: "Usuario",
    lessor: "Arrendador",
    establishment: "Establecimiento",
    appliesWhole: "Todo el anuncio:",
    appliesUnits: "Unidades:",
    noUnits: "Ninguna unidad la usa",
    allUnits: "Todas las unidades ({count})",
    moreUnits: "+{count} más",
    andMore: "y {count} más",
    emptyList: "Aún no has conectado ninguna cuenta de SES Hospedajes.",
    withoutAccountTitle: "Sin cuenta:",
    withoutAccountText: "Sus check-in no se comunican a SES Hospedajes.",
    addAccount: "Añadir cuenta",
    edit: "Editar",
    remove: "Quitar",
    newTitle: "Nueva cuenta de SES Hospedajes",
    editTitle: "Editar cuenta de SES Hospedajes",
    aliasLabel: "Nombre de la cuenta (opcional)",
    aliasPlaceholder: "Ej.: Áticos, Apartamento 2B",
    aliasHint: "Solo sirve para reconocerla aquí. Si lo dejas vacío, se muestra por su código de establecimiento.",
    loginTitle: "Acceso al Ministerio",
    loginSame: "El mismo usuario y contraseña",
    loginSameHint: "Solo escribes los códigos de esta cuenta.",
    loginOwn: "Otro usuario y contraseña",
    loginFrom: "Tomar el acceso de",
    passwordKeep: "Déjala vacía para no cambiarla",
    passwordNeeded: "Escribe la contraseña del nuevo usuario.",
    passwordShared: "Otras cuentas del anuncio usan este usuario ({count}): si cambias la contraseña, se actualiza en todas.",
    scopeTitle: "¿A qué unidades se aplica?",
    scopeWhole: "Todo el anuncio",
    scopeWholeHint: "La usan las unidades que no tengan otra cuenta.",
    scopeWholeTaken: "Ya lo es «{name}».",
    scopeUnits: "Solo algunas unidades",
    scopeUnitsHint: "Tú eliges cuáles.",
    unitNow: "ahora: {name}",
    unitNowWhole: "ahora: la de todo el anuncio",
    unitNowNone: "sin cuenta",
    leftWithout: "sin cuenta al guardar. Sus check-in dejarán de comunicarse a SES Hospedajes.",
    leftToWhole: "al guardar se comunicará con la cuenta de todo el anuncio «{name}».",
    errUnits: "Elige al menos una unidad.",
    errDefaultExists: "Este anuncio ya tiene una cuenta para todas sus unidades.",
    errDuplicate: "Ya tienes esa cuenta en este anuncio. Edítala y añádele unidades.",
    errCopyFrom: "No se pudo tomar el acceso de esa cuenta. Escríbelo a mano.",
    savedValidated: "Cuenta guardada y validada por el Ministerio.",
    savedNotValidated: "Guardada, pero el Ministerio no acepta los datos. Revísalos.",
    savedUnchecked: "Cuenta guardada. El TRA no deja comprobar el token por adelantado: se sabrá en el primer envío.",
    passwordSynced: "Contraseña actualizada también en {count} cuenta(s) con el mismo usuario.",
    removeTitle: "¿Quitar esta cuenta?",
    removeNoUnits: "Se quitará la cuenta «{name}». Ninguna unidad la está usando.",
    removeToFallback: "Se quitará «{name}». Las unidades que la usan ({units}) comunicarán con la cuenta de todo el anuncio «{fallback}».",
    removeToNothing: "Se quitará «{name}». Las unidades que la usan ({units}) se quedarán sin cuenta y sus check-in dejarán de comunicarse a SES Hospedajes.",
    removeConfirm: "Sí, quitar",
    removed: "Cuenta quitada.",
    removeError: "No se pudo quitar la cuenta.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Cargando las cuentas…",
    saving: "Guardando…",
    close: "Cerrar",
    show: "Mostrar",
    hide: "Ocultar",

    badgeConnected: "Conectada",
    badgeError: "Error de validación",
    badgePending: "Sin validar",
    badgeOnSend: "Se comprueba al enviar",

    edit: "Editar",
    remove: "Quitar",
    addAccount: "Añadir cuenta",

    appliesWhole: "Todo el anuncio:",
    appliesUnits: "Unidades:",
    noUnits: "Ninguna unidad la usa",
    allUnits: "Todas las unidades ({count})",
    moreUnits: "+{count} más",
    andMore: "y {count} más",
    withoutAccountTitle: "Sin cuenta:",

    scopeTitle: "¿A qué unidades se aplica?",
    scopeWhole: "Todo el anuncio",
    scopeWholeHint: "La usan las unidades que no tengan otra cuenta.",
    scopeWholeTaken: "Ya lo es «{name}».",
    scopeUnits: "Solo algunas unidades",
    scopeUnitsHint: "Tú eliges cuáles.",
    unitNow: "ahora: {name}",
    unitNowWhole: "ahora: la de todo el anuncio",
    unitNowNone: "sin cuenta",
    leftToWhole: "al guardar se comunicará con la cuenta de todo el anuncio «{name}».",

    aliasLabel: "Nombre de la cuenta (opcional)",
    aliasPlaceholder: "Ej.: Torre norte, Apartamento 301",
    loginFrom: "Tomar el acceso de",
    secretKeep: "Déjalo vacío para no cambiarlo",

    errUnits: "Elige al menos una unidad.",
    errDefaultExists: "Este anuncio ya tiene una cuenta para todas sus unidades.",
    errDuplicate: "Ya tienes esa cuenta en este anuncio. Edítala y añádele unidades.",
    errCopyFrom: "No se pudo tomar el acceso de esa cuenta. Escríbelo a mano.",
    errNoListing: "No encontramos el anuncio. Vuelve a abrir la pantalla.",
    saveError: "No se pudo guardar la cuenta.",

    removeTitle: "¿Quitar esta cuenta?",
    removeConfirm: "Sí, quitar",
    removeNoUnits: "Se quitará la cuenta «{name}». Ninguna unidad la está usando.",
    removeToFallback: "Se quitará «{name}». Las unidades que la usan ({units}) comunicarán con la cuenta de todo el anuncio «{fallback}».",
    removeToNothing: "Se quitará «{name}». Las unidades que la usan ({units}) se quedarán sin cuenta y dejarán de informar a {authority}.",
    removed: "Cuenta quitada.",
    removeError: "No se pudo quitar la cuenta.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Cada unidad informa sus huéspedes al SIRE con una cuenta. Puedes usar una sola para todo el anuncio o poner una distinta a algunas unidades, por ejemplo si cada apartamento está dado de alta con su propio código de establecimiento.",
      introSingle: "Conecta la cuenta con la que este anuncio informa sus huéspedes al SIRE.",
      emptyList: "Aún no has conectado ninguna cuenta del SIRE.",
      withoutAccountText: "Sus check-in no se informan al SIRE.",
      newTitle: "Nueva cuenta del SIRE",
      editTitle: "Editar cuenta del SIRE",
      modalSub: "Son los datos con los que entras al SIRE",
      defaultName: "Establecimiento {code}",
      defaultNameDoc: "Documento {document}",
      docTypeLabel: "Tipo de documento",
      docType_CO_ID: "Cédula de ciudadanía",
      docType_CO_FID: "Cédula de extranjería",
      documentLabel: "Número de documento",
      documentPlaceholder: "Ej.: 1012345678",
      documentHint: "Es el usuario con el que entras al SIRE.",
      passwordLabel: "Contraseña",
      passwordPlaceholder: "La contraseña del SIRE",
      passwordShared: "Otras cuentas del anuncio usan este documento ({count}): si cambias la contraseña, se actualiza en todas.",
      estLabel: "Código de establecimiento (opcional)",
      estPlaceholder: "Ej.: 67890",
      estHint: "Solo hace falta si con el mismo acceso informas de varios alojamientos. Si lo dejas vacío, se usa el que tengas dado de alta.",
      loginTitle: "Acceso al SIRE",
      loginSame: "El mismo documento y contraseña",
      loginSameHint: "Solo escribes el código de esta cuenta.",
      loginOwn: "Otro documento y contraseña",
      aliasHint: "Solo sirve para reconocerla aquí. Si lo dejas vacío, se muestra por su código de establecimiento.",
      metaDoc: "Documento",
      metaEst: "Establecimiento",
      leftWithout: "sin cuenta al guardar. Sus check-in dejarán de informarse al SIRE.",
      errDocument: "Escribe el número de documento.",
      errPassword: "Escribe la contraseña del SIRE.",
      errPasswordNeeded: "Escribe la contraseña del nuevo documento.",
      savedValidated: "Cuenta guardada y validada por el SIRE.",
      savedNotValidated: "Guardada, pero el SIRE no acepta los datos. Revísalos.",
      savedUnchecked: "Cuenta guardada. El TRA no deja comprobar el token por adelantado: se sabrá en el primer envío.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Cada unidad envía su informe al TRA con una cuenta. Puedes usar una sola para todo el anuncio o poner una distinta a algunas unidades: cada RNT identifica a un alojamiento.",
      introSingle: "Conecta la cuenta con la que este anuncio envía su informe al TRA.",
      emptyList: "Aún no has conectado ninguna cuenta del TRA.",
      withoutAccountText: "Sus estancias no se informan al TRA.",
      newTitle: "Nueva cuenta del TRA",
      editTitle: "Editar cuenta del TRA",
      modalSub: "Son el token y el RNT de este alojamiento",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Pega aquí tu token",
      tokenHint: "Lo generas en",
      loginTitle: "Acceso al TRA",
      loginSame: "El mismo token",
      loginSameHint: "Solo escribes el RNT de esta cuenta.",
      loginOwn: "Otro token",
      rntLabel: "RNT",
      rntPlaceholder: "Ej.: 123456",
      rntHint: "El Registro Nacional de Turismo de este alojamiento. Es lo que identifica al establecimiento ante el TRA.",
      aliasHint: "Solo sirve para reconocerla aquí. Si lo dejas vacío, se muestra por su RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "sin cuenta al guardar. Sus estancias dejarán de informarse al TRA.",
      errToken: "Pega el token del TRA.",
      errRnt: "El RNT es un número. Revísalo.",
      savedValidated: "Cuenta guardada y validada por el TRA.",
      savedNotValidated: "Guardada, pero el TRA no acepta los datos. Revísalos.",
      savedUnchecked: "Cuenta guardada. El TRA no deja comprobar el token por adelantado: se sabrá en el primer envío.",
    },

    foreign: {
      ses: "SES Hospedajes (España)",
      colombia: "SIRE y TRA (Colombia)",
      title: "Quedan cuentas de {name}",
      text: "Este anuncio ya no es de ese país, así que esa cuenta no informa nada. | Este anuncio ya no es de ese país, así que esas {count} cuentas no informan nada.",
      remove: "Quitarlas",
      removeTitle: "¿Quitar las cuentas que sobran?",
      removeMessage: "Se quitará la cuenta de {name} que quedó de antes. No afecta a la autoridad que usas ahora. | Se quitarán las {count} cuentas de {name} que quedaron de antes. No afecta a la autoridad que usas ahora.",
      removed: "Cuentas quitadas.",
      removeError: "No se pudieron quitar.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Mensaje de salida",
    subtitle: "Recordatorio de checkout que se envía la víspera de la salida. Escribe tu propio texto y usa las variables disponibles.",
    loading: "Cargando…",
    enableTitle: "Enviar mensaje de salida",
    enableSub: "Se enviará automáticamente {day} a las {time}.",
    dayLast: "el día de salida",
    dayBefore: "el día anterior a la salida",
    cloneTitleNoun: "mensaje de salida",
    cloneItemNoun: "el mensaje de salida",
    whenLabel: "Cuándo se envía",
    dayBeforeShort: "Día anterior",
    dayLastShort: "Día de la salida",
    atLabel: "A las",
    timeHint: "El día de la salida la hora no puede superar la del check-out ({time}).",
    otaTitle: "Enviar también por OTA",
    textLabel: "Texto del mensaje de salida",
    translate: "Traducir",
    translating: "Traduciendo…",
    attach: "Adjuntar",
    uploading: "Subiendo…",
    attachTitle: "Adjuntos del mensaje de salida",
    emojis: "Emojis",
    searchEmoji: "Buscar emoji…",
    variables: "Variables",
    varsHint: "Pulsa para insertarlas. Se reemplazan por los datos reales de la reserva al enviarse.",
    uploadDone: "Enviado. Guardándolo en el servidor…",
    attachLimits: "Imágenes y PDF hasta {file} MB · Vídeos en MP4 hasta {video} MB.",
    attachLimitsWhy: "Son los límites que admite WhatsApp.",
    tipBefore: "Usa",
    tipTextWord: "texto",
    tipMid: "para poner algo en",
    tipBoldWord: "negrita",
    tipAfter: "(formato de WhatsApp). El huésped recibe el mensaje en su idioma si está configurado.",
    attachShared: "Adjuntos · compartidos entre todos los idiomas",
    delete: "Eliminar",
    autosaveNote: "Los cambios se guardan automáticamente.",
    preview: "Vista previa",
    online: "en línea",
    previewHint: "Se actualiza con tu configuración",
    dayOfCheckout: "Día de salida",
    eveOfCheckout: "Víspera de salida",
    yourAccommodation: "tu alojamiento",
    uploadSent: "{sent} de {total} MB",
    filesCount: "{count} archivos",
    placeholder: "Ej. Hola {guest} 👋 Mañana finaliza tu estancia en {property}. La hora de salida es a las {time}. ¡Gracias por tu visita!",
    varGuestName: "Nombre del huésped",
    varPropertyName: "Nombre del alojamiento",
    varCheckoutTime: "Hora de salida",
    today: "hoy",
    tomorrow: "mañana",
    previewDefault: "Hola, *{guest}* 👋\n\nTe recordamos que {when} finaliza tu estancia en *{property}*.\n\n🕚 La hora máxima de salida es a las *{time}*.\n\nMuchas gracias por tu estancia. ¡Buen viaje! 😊",
    errVideoFormat: "❌ {name} es un vídeo {ext} y WhatsApp solo admite MP4. Conviértelo a MP4 y vuelve a subirlo.",
    errFileSize: "❌ {name} pesa {size} MB y el máximo son {max} MB. ",
    errFileSizeVideo: "WhatsApp no admite vídeos más grandes: comprímelo o recórtalo.",
    errFileSizeFile: "WhatsApp no admite archivos más grandes.",
    attachUploaded: "Adjunto(s) subido(s) correctamente",
    attachUploadError: "Error subiendo adjuntos",
    attachDeleted: "Adjunto eliminado",
    attachDeleteError: "No se pudo eliminar el adjunto",
    loadError: "No se pudo cargar el mensaje de salida.",
    translateEmpty: "Escribe el mensaje en el idioma activo antes de traducir.",
    translateSuccess: "¡{count} idiomas traducidos! Revisa cada pestaña.",
    translatePartial: "{ok} traducidos, {fail} fallaron.",
    translateError: "No se pudo traducir. Inténtalo de nuevo.",
    saved: "Mensaje de salida guardado",
    saveError: "No se pudo guardar el mensaje de salida.",
  },
};
